import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import toast, { Toaster } from "react-hot-toast";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { openAdminChat } from "../../../utils/openAdminChat";

const SupplierLead = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  let is_alert = false;
  // Get the profile JSON string from localStorage
  const profileString = localStorage.getItem("profile");
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userType = user?.user_type;

  let admin_id = null;
  let token = null;

  if (profileString) {
    try {
      if (profileString != "undefined" || profileString === null) {
        const profile = JSON.parse(profileString);
        admin_id = profile.id || profile.admin_id; // Choose the one you need
        token = profile.token || profile.access_token; // Choose the one you need
      }
    } catch (err) {
      console.error("Failed to parse profile:", err);
    }
  }

  const [data, setData] = useState([]);
  const [totalpage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [monthFilter, setMonthFilter] = useState("");

  useEffect(() => {
    return () => {
      if (location.state !== null) {
        if (is_alert === false) {
          toast.success(location.state);
        }

        is_alert = true;
      }
      window.history.replaceState({}, location.state);
    };
  }, []);

  const exportToExcel = () => {
    if (data.length === 0) {
      alert("No data to export.");
      return;
    }

    const flattenedData = data.map((item) => ({
      Name: item.user.name,
      Email: item.user.email,
      MobileNumber: item.user.phone,
      CompanyName: item.user.company_name,
      BusinessType: item.user.business_type,
      UserType: item.user.user_type,
      Website: item.user.website,
      Logo: item.user.logo,
    }));

    const worksheet = XLSX.utils.json_to_sheet(flattenedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Products");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(fileData, "supplier-buy-lead.xlsx");
  };

  const handleImportClick = () => {
    document.getElementById("fileInput")?.click();
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

      try {
        const res = await axios.post(
          `${process.env.REACT_APP_URL}/admin/supplier-import-data`,
          { data: jsonData },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
          },
        );

        toast.success(`${res?.data?.message}`);
        SupplierLeadData();
        Navigate("/admin/supplier/list", { state: res.data.msg });

        // alert("Imported successfully");
      } catch (err) {
        console.error("Import failed", err);
        alert("Import failed");
      }
    };

    reader.readAsBinaryString(file);
  };

  const handleWhatsAppClick = (phoneNumber) => {
    window.open(`https://wa.me/${phoneNumber}`, "_blank");
  };

  const handleDownloadFormat = () => {
    // Define headers
    const sampleData = [
      {
        user_type: "Supplier",
        businessType: "Retail",
        name: "John Doe",
        companyName: "ABC Corp",
        phone: "9876543210",
        email: "john@example.com",
        website: "https://abc.com",
        address: "xyz",
        city: "xxxx",
        country: "xxxxx",
        gst_number: "xxxxx",
        pincode: "xxxx",
        designation: "Supplier",
      },
    ];

    const worksheet = XLSX.utils.json_to_sheet(sampleData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Suppliers");

    // Generate XLSX file and trigger download
    XLSX.writeFile(workbook, "supplier-format.xlsx");
  };

  // The row-level "Message" button (RowActions, below) opens the real Live
  // Chat widget from Layout/chatModal.jsx via openAdminChat() instead of the
  // local chat panel this used to be — that panel's WebSocket protocol
  // (admin_send_message/admin_get_message) was never implemented by the
  // backend (websocket/chatSocket.js only understands send_message/
  // get_messages/authenticate etc.), so nothing sent here ever reached
  // anyone.
  const handleOpenChat = (supplier) => {
    openAdminChat({
      user_id: supplier?.user_id,
      name: supplier?.name,
      email: supplier?.email,
      user_type: "supplier",
    });
  };

  const handlePageClick = (e) => {
    setPage(e.selected + 1);
  };

  const SupplierLeadData = () => {
    const monthQuery = monthFilter ? `&month=${monthFilter}` : "";

    axios
      .get(
        `${process.env.REACT_APP_URL}/admin/offline_supplier?page=${page}&search=${search}${monthQuery}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        },
      )
      .then((res) => {
        setTotalPage(res?.data?.data?.pages);
        setData(res?.data?.data?.users);
      })
      .catch((err) => {
        if (err?.response?.data?.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  const HandleActiveDeactive = (id, status) => {
    let statusText = "";
    let Color = "";
    if (status === "active") {
      statusText = "Deactive";
      Color = "#DC3741";
    } else {
      statusText = "Active";
      Color = "#1b55e2";
    }

    Swal.fire({
      title: `Do you want to ${statusText} this Record?`,
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: Color,
      confirmButtonText: statusText,
    }).then((result) => {
      if (result.isConfirmed === true) {
        axios
          .put(
            `${process.env.REACT_APP_URL}/admin/offline_supplier/${id}`,
            {
              approved:
                status == "pending" || status == "inactive" ? true : false,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("Token")}`,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              toast.success(res.data.message);
              SupplierLeadData();
            }
          })
          .catch((err) => {
            const MSG = ["Token not found.", "Invalid token.", "Unauthorized."];
            const STATUS = [401, 403];
            if (
              STATUS.includes(err?.response?.status) ||
              MSG.includes(err?.response?.data?.msg)
            ) {
              localStorage?.clear();
              Navigate("/admin/login");
            } else {
              toast.error(err?.response?.data?.msg);
            }
          });
      }
    });
  };

  useEffect(() => {
    SupplierLeadData();
  }, [page, search, monthFilter]);

  const initialsOf = (name = "") =>
    name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";
  const TINTS = [
    { bg: "var(--color-info-bg)", color: "var(--color-info-text)" },
    { bg: "var(--color-success-bg)", color: "var(--color-success-text)" },
    { bg: "var(--color-violet-bg)", color: "var(--color-violet-text)" },
    { bg: "var(--color-warning-bg)", color: "var(--color-warning-text)" },
  ];
  const tint = (s = "") => TINTS[(String(s).length) % TINTS.length];
  const fmt = (d) =>
    d ? new Date(d).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false }) : "—";

  const [dense, setDense] = useState(false);
  const [sortDir, setSortDir] = useState("");
  const [isMobileView, setIsMobileView] = useState(typeof window !== "undefined" && window.innerWidth < 768);
  useEffect(() => {
    const h = () => setIsMobileView(window.innerWidth < 768);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);

  let displayData = [...(data || [])];
  if (sortDir) {
    displayData.sort((a, b) => {
      const av = (a?.name || "").toLowerCase();
      const bv = (b?.name || "").toLowerCase();
      if (av < bv) return sortDir === "asc" ? -1 : 1;
      if (av > bv) return sortDir === "asc" ? 1 : -1;
      return 0;
    });
  }

  const ApprovedToggle = ({ item }) => (
    <button type="button" className={`al-toggle ${item?.status === "active" ? "is-on" : ""}`}
      title={item?.status === "active" ? "Deactivate" : "Activate"}
      onClick={() => HandleActiveDeactive(item?.user_id, item?.status)}>
      <span className="al-toggle__knob" />
    </button>
  );

  const viewState = (item) => ({
    state: {
      id: item?.user_id, name: item?.name, company_name: item?.company_name,
      designation: item?.designation, status: item?.status, email: item?.email,
      country: item?.addresses?.[0]?.country, city: item?.addresses?.[0]?.city,
      created_at: item?.created_at, gst_number: item?.gst_number, phone: item?.phone,
      state: item?.addresses?.[0]?.state, address: item?.addresses?.[0]?.address,
      pincode: item?.addresses?.[0]?.pincode, user_type: item?.user_type,
      machine_configuration: item?.machine_configuration, business_type: item?.business_type,
      website: item?.website, logo_image: item?.logo_image, bank_details: item?.bank_details,
    },
  });

  const RowActions = ({ item }) => (
    <div className="al-actions">
      <button type="button" className="al-act" title="View"
        onClick={() => Navigate("/admin/supplier/show", viewState(item))}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
      </button>
      <button type="button" className="al-act" title="WhatsApp" style={{ color: "#25D366" }}
        onClick={() => handleWhatsAppClick(item?.user?.phone)}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7A8.38 8.38 0 014 11.5a8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"/></svg>
      </button>
      <button type="button" className="al-act" title="Message supplier" style={{ color: "#1b55e2" }}
        disabled={!item?.user_id}
        onClick={() => handleOpenChat(item)}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
      </button>
    </div>
  );

  const GRID = { gridTemplateColumns: "1.6fr 1.7fr 1.1fr .9fr 1.1fr 118px" };

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Suppliers</h1>
          <p className="al-sub">Registered suppliers, their performance and approval status.</p>
        </div>
        <div className="al-head__actions">
          {userType === "admin" && (
            <>
              <button type="button" className="al-btn" onClick={handleDownloadFormat}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                Download Format
              </button>
              <button type="button" className="al-btn" onClick={handleImportClick}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                Import
              </button>
              <input type="file" id="fileInput" accept=".csv,.xlsx,.xls" style={{ display: "none" }} onChange={handleFileUpload} />
              <button type="button" className="al-btn" onClick={exportToExcel}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                Export
              </button>
            </>
          )}
          <button type="button" className="al-btn al-btn--primary" onClick={() => Navigate("/admin/supplier/add")}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            Add Supplier
          </button>
        </div>
      </div>

      <div className="al-card">
        <div className="al-toolbar">
          <div className="al-search">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--color-text-tertiary)" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
            <input type="search" placeholder="Search suppliers by name, company…"
              onKeyDown={(e) => e.key === "Enter" && search !== "" && SupplierLeadData()}
              onChange={(e) => setSearch(e.target.value)} />
          </div>
          <div className="al-select">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            <select value={monthFilter} onChange={(e) => { setMonthFilter(e.target.value); }}>
              <option value="">Select Month</option>
              <option value="All">All</option>
              <option value="1">Last 1 Month</option>
              <option value="3">Last 3 Months</option>
              <option value="6">Last 6 Months</option>
            </select>
          </div>
          <button type="button" className="al-tool" style={{ marginLeft: "auto" }} onClick={() => setDense((d) => !d)} title="Toggle density">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
            {dense ? "Comfortable" : "Density"}
          </button>
        </div>

        {!isMobileView ? (
          <div className="al-tablewrap">
            <div style={{ minWidth: 980, "--al-row-pad": dense ? "8px" : "13px" }}>
              <div className="al-thead" style={GRID}>
                <span className="al-th al-th--sort" onClick={() => setSortDir((d) => (d === "asc" ? "desc" : d === "desc" ? "" : "asc"))}>
                  Name
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: sortDir ? 1 : 0.45, transform: sortDir === "desc" ? "rotate(180deg)" : "none" }}><polyline points="18 15 12 9 6 15"/></svg>
                </span>
                <span className="al-th">Email</span>
                <span className="al-th">Mobile Number</span>
                <span className="al-th">Approved</span>
                <span className="al-th">Date &amp; Time</span>
                <span className="al-th al-th--right">Action</span>
              </div>

              {displayData && displayData.length > 0 ? (
                displayData.map((item, index) => {
                  const t = tint(item?.name);
                  return (
                    <div className="al-row" style={GRID} key={index}>
                      <div className="al-id">
                        <span className="al-avatar" style={{ background: t.bg, color: t.color }}>{initialsOf(item?.name)}</span>
                        <span className="al-name">{item?.name}</span>
                      </div>
                      <span className="al-muted al-ellipsis" title={item?.email}>{item?.email}</span>
                      <span className="al-mono al-muted">{item?.phone}</span>
                      <span><ApprovedToggle item={item} /></span>
                      <span className="al-mono al-muted">{fmt(item?.created_at)}</span>
                      <RowActions item={item} />
                    </div>
                  );
                })
              ) : (
                <div className="al-empty">
                  <div className="al-empty__icon">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1"/></svg>
                  </div>
                  <p className="al-empty__title">No Record Found</p>
                  <p className="al-empty__text">Try a different search or add a supplier.</p>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="al-mobile">
            {displayData && displayData.length > 0 ? (
              displayData.map((item, index) => {
                const t = tint(item?.name);
                return (
                  <div className="al-mcard" key={index}>
                    <div className="al-mcard__top">
                      <span className="al-avatar" style={{ background: t.bg, color: t.color }}>{initialsOf(item?.name)}</span>
                      <div className="al-name" style={{ flex: 1 }}>{item?.name}</div>
                      <ApprovedToggle item={item} />
                    </div>
                    <div className="al-mrow"><span className="al-muted">Email</span><span>{item?.email}</span></div>
                    <div className="al-mrow"><span className="al-muted">Mobile</span><span className="al-mono">{item?.phone}</span></div>
                    <div className="al-mrow"><span className="al-muted">Date</span><span className="al-mono al-muted">{fmt(item?.created_at)}</span></div>
                    <div className="al-mactions"><RowActions item={item} /></div>
                  </div>
                );
              })
            ) : (
              <div className="al-empty"><p className="al-empty__title">No Record Found</p></div>
            )}
          </div>
        )}

        <div className="al-foot">
          <span className="al-foot__info">Showing <strong>{displayData?.length || 0}</strong> suppliers</span>
          {data?.length !== 0 && (
            <ReactPaginate
              previousLabel={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>}
              nextLabel={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>}
              breakLabel={"..."}
              pageCount={totalpage}
              marginPagesDisplayed={2}
              pageRangeDisplayed={2}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-end m-0"}
              pageClassName={"page-item"} pageLinkClassName={"page-link"}
              previousClassName={"page-item"} previousLinkClassName={"page-link"}
              nextClassName={"page-item"} nextLinkClassName={"page-link"}
              breakClassName={"page-item"} breakLinkClassName={"page-link"}
              activeClassName={"active"} />
          )}
        </div>
      </div>

    </div>
  );
};

export default SupplierLead;
